<template>
  <div id="sessionsDoomYogaDiv" class="sessions-container-doomyoga">
    <div
      class="container mb-3"
      v-for="item in upcoming_sessions"
      :key="item.day"
    >
      <h5 class="sessionDayH5 ml-2 mb-0">{{ item.day }}</h5>
      <div v-for="event in item.sessions" :key="event.id" class="row px-2">
        <div class="col-2">
          <h3 class="sessionTimeH3 float-right">
            {{ event.time }}
          </h3>
        </div>
        <div class="col-10 doom-yoga-border-div p-3 my-2">
          <div class="row">
            <div class="col-1">
              <div v-if="select_event">
                <!-- <input
                  type="checkbox"
                  name="selectedEvents[]"
                  v-bind:value="event.id"
                /> -->
                <b-form-checkbox
                class="form-checkbox-dy"
                  v-model="selectedEvents"
                  name="selectedEvents[]"
                  :value="event.id"
                >
                </b-form-checkbox>
              </div>
              <img
                v-else
                class="dashboard-session-img"
                src="@/assets/images/doom-yoga/dashboard-yoga-icon.png"
                alt="yoga icon"
              />
            </div>
            <div class="col-8 pl-0">
              <h4 class="eventNameH4">{{ event.name }}</h4>
              <p class="eventDescriptionP">
                {{ event.description }}
              </p>
            </div>
            <div class="col-3 px-0">
              <div>
                <img
                  class="sessionIconImg"
                  src="@/assets/images/doom-yoga/location-icon.png"
                  alt="location"
                />
                <p class="sessionIconP my-auto">
                  {{ event.location }}
                </p>
              </div>
              <div class="mt-1">
                <img
                  class="sessionIconImg"
                  src="@/assets/images/doom-yoga/users-icon.png"
                  alt="location"
                />
                <p class="sessionIconP sessionIconRedP my-auto">
                  {{ event.participants }}/{{ event.max_participants }}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import $ from "jquery";

export default {
  name: "EventsCalendarList",
  props: [
    "client_name",
    "select_event",
    "filter_buttons",
    "events",
    "currency",
    "images_folder",
    "sub_title",
  ],
  data() {
    return {
      upcoming_sessions: [
        {
          day: "Tuesday, February 22",
          sessions: [
            {
              id: 1,
              time: "6:00 pm",
              duration: "1hr",
              name: "DO.OM YOGA ONLINE PRACTICE ",
              description: "Description",
              location: "ZOOM ONLINE",
              max_participants: 150,
              participants: 20,
            },
            {
              id: 2,
              time: "8:00 pm",
              duration: "1hr 30 min",
              name: "1TO1 DO.OM YOGA PRIVATE TUTORIAL ",
              description: "Description",
              location: "ZOOM ONLINE",
              max_participants: 150,
              participants: 20,
            },
          ],
        },
        {
          day: "Wednesday, February 23",
          sessions: [
            {
              id: 3,
              time: "6:00 pm",
              duration: "1hr",
              name: "DO.OM YOGA ONLINE PRACTICE ",
              description: "Description",
              location: "ZOOM ONLINE",
              max_participants: 150,
              participants: 20,
            },
            {
              id: 4,
              time: "8:00 pm",
              duration: "1hr 30 min",
              name: "1TO1 DO.OM YOGA PRIVATE TUTORIAL ",
              description: "Description",
              location: "ZOOM ONLINE",
              max_participants: 150,
              participants: 20,
            },
          ],
        },
      ],
      selectedEvents: [],
    };
  },
  watch: {
    selectedEvents(newval, oldval) {
      console.log("watch selected events");
      console.log(newval);
    },
  },
  mounted() {
    console.log(this.select_event);
  },
};
</script>


// WEBPACK FOOTER //
// src/components/events/CalendarList.vue